export const Constants = {
  numberOfMinimumCharactersForName: 3,
  numberOfMaximumCharactersForName: 255,
  numberOfCardsDisplayed: 10,
};
